export interface PendingCopilotSettlement {
  scopeKey: string;
  conversationId: string;
  previousTurnId: string | null;
  turnId: string | null;
  kind?: "message" | "approval";
  previousSettlementRevision?: number;
}

export function isCopilotSettlementReady({
  pending,
  scopeKey,
  conversationId,
  serverTurnId,
  turnStatus,
  settlementRevision,
  localRuntimeRunning,
}: {
  pending: PendingCopilotSettlement | null;
  scopeKey: string | null;
  conversationId: string | null;
  serverTurnId: string | null;
  turnStatus: string | null;
  settlementRevision?: number;
  localRuntimeRunning: boolean;
}): boolean {
  if (pending?.kind === "approval") {
    return (
      pending.scopeKey === scopeKey &&
      pending.conversationId === conversationId &&
      pending.turnId !== null &&
      pending.turnId === serverTurnId &&
      settlementRevision !== undefined &&
      settlementRevision > (pending.previousSettlementRevision ?? -1) &&
      turnStatus !== "running" &&
      !localRuntimeRunning
    );
  }
  return (
    pending !== null &&
    scopeKey !== null &&
    conversationId !== null &&
    pending.scopeKey === scopeKey &&
    pending.conversationId === conversationId &&
    pending.turnId !== null &&
    pending.turnId === serverTurnId &&
    turnStatus !== "running" &&
    !localRuntimeRunning
  );
}

export function observeCopilotServerTurn(
  pending: PendingCopilotSettlement,
  serverTurnId: string | null,
): PendingCopilotSettlement {
  if (!serverTurnId || serverTurnId === pending.previousTurnId) return pending;
  return { ...pending, turnId: serverTurnId };
}

export function withoutApprovalSettlement(
  pending: PendingCopilotSettlement | null,
): PendingCopilotSettlement | null {
  return pending?.kind === "approval" ? null : pending;
}
